import { Box } from "../../box";
import { mergeProps } from "../../shared";
import { TabPanel } from "./TabPanel";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function TabPanels({
  as = DefaultElement,
  panels,
  ...rest
}) {
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: "o-ui-tab-panels"
    }),
    children: panels.map(({
      key,
      elementType: ElementType = TabPanel,
      ref,
      tabId,
      panelId,
      props
    }) => /*#__PURE__*/_createElement(ElementType, { ...props,
      key: key,
      panel: {
        key,
        panelId,
        tabId
      },
      ref: ref
    }))
  });
}